import type { SyntheticEvent } from '@/components/viewPort/SyntheticEvent';
import type { ImagesService } from './Images.service';
import type { SliceType } from './interfaces';
import type { IKeyboardHandler } from '@/components/viewPort/KeyboardController.ts';
import type { PointerSyntheticEvent } from '@/components/viewPort/PointerSyntheticEvent';

export class KeyboardImagesHandler implements IKeyboardHandler {
  private readonly _sliceType: SliceType;

  private _imagesService: ImagesService;

  private _isInFocus = false;

  public constructor(imagesService: ImagesService, sliceType: SliceType) {
    this._imagesService = imagesService;
    this._sliceType = sliceType;
  }

  public onPointerEnter(event: PointerSyntheticEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this._isInFocus = true;
  }

  public onPointerLeave(event: PointerSyntheticEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this._isInFocus = false;
  }

  public onPointerCancel(): void {
    this._isInFocus = false;
  }

  public onKeyDown(event: SyntheticEvent<KeyboardEvent>): void {
    event.stopPropagation();
    event.preventDefault();

    if (!this._isInFocus) return;

    const imagesInfo = this._imagesService.getImageSliceOrientationInfo(this._sliceType);
    const slicesCount = imagesInfo.slicesCount;
    const sliceIndex = imagesInfo.currentSlice;

    if (typeof slicesCount === 'undefined' || typeof sliceIndex === 'undefined') {
      return;
    }

    let delta = 0;
    switch (event.originalEvent.key) {
      case 'ArrowUp':
        delta = 1;
        break;
      case 'ArrowDown':
        delta = -1;
        break;
      default:
        return;
    }

    const sliceToRequest = sliceIndex + delta;

    if (sliceToRequest >= 0 && sliceToRequest < slicesCount) {
      this._imagesService.requestSlice(this._sliceType, sliceToRequest);
    }
  }
}
